import React, { useState, useEffect, useContext, Component } from 'react';
 import Header from '../../components/Header';
import Footer from '../../components/Footer';

const TestingDoctorList = () => {

    return (
        <>
            <Header />

            <main className="page">
 
<section className="container py-4">

  {/* ✅ SUPER ATTRACTIVE FILTER BAR */}
  <div className="glassbar p-3 mb-4">
    <div className="row g-3 align-items-center">

      {/* Search */}
      <div className="col-lg-5">
        <div className="pill-search d-flex align-items-center gap-2">
          <span className="text-muted">🔎</span>
          <input
            className="form-control border-0 bg-transparent p-0 shadow-none"
            placeholder="Search doctor, specialty, treatment…"
          />
        </div>
      </div>

      {/* Chips */}
      <div className="col-lg-5">
        <div className="d-flex gap-2 flex-wrap">
          <button className="chip active" type="button">All</button>
          <button className="chip" type="button">General</button>
          <button className="chip" type="button">Implants</button>
          <button className="chip" type="button">Aligners</button>
          <button className="chip" type="button">Kids</button>
          <button className="chip" type="button">Cosmetic</button>
        </div>
      </div>

      {/* Sort + Filter Drawer */}
      <div className="col-lg-2 d-flex gap-2 justify-content-lg-end">
        <select className="form-select">
          <option>Sort: Recommended</option>
          <option>Experience: High → Low</option>
          <option>Experience: Low → High</option>
          <option>Rating: High → Low</option>
        </select>

        <button
          className="btn btn-primary"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#filtersDrawer"
        >
          Filters
        </button>
      </div>

      {/* Active Filters + Count */}
      <div className="col-12">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="small text-muted">
            Showing <b>6 doctors</b> near you
          </div>

          <div className="d-flex gap-2 flex-wrap align-items-center">
            <span className="chip active">City: Gurgaon ✕</span>
            <span className="chip active">10+ yrs ✕</span>
            <button className="btn btn-link text-decoration-none p-0 small">
              Clear all
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  {/* ✅ 6 DOCTOR CARDS */}
  <div className="row g-4">

    {[
      {
        name:"Dr Abhiruchi Gupta",
        spec:"General Dentistry • Aesthetic",
        city:"Hyderabad",
        exp:"24 Yrs Exp",
        rating:"4.9",
        skills:["Smile Design","Fillings","RCT","Rehab"],
      },
      {
        name:"Dr Abinaya K",
        spec:"Implant Prosthodontist",
        city:"Chennai",
        exp:"15 Yrs Exp",
        rating:"4.8",
        skills:["Crowns","Implants","Smile Design","General"],
      },
      {
        name:"Dr Aditee Jhingan",
        spec:"Oral Medicine & Radiology",
        city:"Gurgaon",
        exp:"10 Yrs Exp",
        rating:"4.7",
        skills:["Fillings","TMJ","Soft Tissue","General"],
      },
      {
        name:"Dr Adrita Nag",
        spec:"Oral Medicine & Radiology",
        city:"Delhi",
        exp:"23 Yrs Exp",
        rating:"4.8",
        skills:["Fillings","Whitening","Crowns","Smile Design"],
      },
      {
        name:"Dr Ajay Sangwan",
        spec:"Prosthodontist",
        city:"Delhi",
        exp:"15 Yrs Exp",
        rating:"4.9",
        skills:["Crowns","Laminates","Post & Core","Smile"],
      },
      {
        name:"Dr Akanksha Jha",
        spec:"General Dentistry",
        city:"Hyderabad",
        exp:"15 Yrs Exp",
        rating:"4.7",
        skills:["General","Aesthetic","RCT","Crowns"],
      },
    ].map((d, idx) => (
      <div className="col-lg-4 col-md-6" key={idx}>
        <div className="doctor-card p-4 h-100">
   

          {/* Header */}
          <div className="d-flex gap-3 align-items-start">
            <div className='d-inline-flex flex-column align-items-center gap-2'>

            <img className="avatar m-0 object-fit-cover d-inline-block" style={{aspectRatio:'1/1',}} src="https://bigapollospectra.com/assets/uploads/doctor-45.jpeg" alt="doctor" />
             <span className="exp-pill d-inline-block small">{d.exp}</span>
             </div>

                   <div className="flex-grow-1">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="fw-bold" style={{color:"var(--navy)"}}>{d.name}</div>
                <span className="verified">✔ Verified</span>
              </div>

              <div className="small text-muted">{d.spec}</div>

              <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
                <span className="badge bg-primary-subtle text-primary rounded-pill">
                  ★ {d.rating}
                </span>
                <span className="badge bg-light text-dark border rounded-pill">
                  📍 {d.city}
                </span>
                <span className="badge bg-light text-dark border rounded-pill">
                  Slots Today
                </span>
              </div>
            </div>
          </div>

          <div className="soft-divider my-3" />

          {/* Qualification + Expertise */}
          <div className="row g-2">
            <div className="col-6">
              <div className="small fw-semibold mb-1">Qualification</div>
              <div className="small text-muted">MDS / BDS</div>
            </div>
            <div className="col-6 text-end">
              <div className="small fw-semibold mb-1">Languages</div>
              <div className="small text-muted">Hindi, English</div>
            </div>
          </div>

          <div className="small fw-semibold mt-3 mb-2">Expertise</div>
          <div className="d-flex flex-wrap gap-2 mb-4">
            {d.skills.map((s, i) => (
              <span className="skill" key={i}>✓ {s}</span>
            ))}
          </div>

          {/* CTA */}
          <div className="d-flex gap-2">
            <button className="btn btn-outline-primary w-50 rounded-pill">
              View Profile
            </button>
            <button className="btn btn-primary w-50 rounded-pill">
              Book Now →
            </button>
          </div>
        </div>
      </div>
    ))}

  </div>

  {/* ✅ OFFCANVAS FILTER DRAWER */}
  <div className="offcanvas offcanvas-end" tabIndex="-1" id="filtersDrawer">
    <div className="offcanvas-header">
      <h5 className="offcanvas-title fw-bold">Refine Results</h5>
      <button type="button" className="btn-close" data-bs-dismiss="offcanvas" />
    </div>

    <div className="offcanvas-body">
      <div className="mb-3">
        <label className="form-label fw-semibold">City</label>
        <select className="form-select">
          <option>All Cities</option>
          <option>Delhi</option>
          <option>Gurgaon</option>
          <option>Hyderabad</option>
          <option>Chennai</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Specialty</label>
        <select className="form-select">
          <option>All Specialties</option>
          <option>General Dentistry</option>
          <option>Implant Specialist</option>
          <option>Prosthodontist</option>
          <option>Oral Medicine</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Experience</label>
        <div className="d-flex flex-wrap gap-2">
          <button className="chip" type="button">0–5 yrs</button>
          <button className="chip" type="button">5–10 yrs</button>
          <button className="chip active" type="button">10–15 yrs</button>
          <button className="chip" type="button">15+ yrs</button>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Availability</label>
        <div className="d-flex flex-wrap gap-2">
          <button className="chip" type="button">Today</button>
          <button className="chip" type="button">Tomorrow</button>
          <button className="chip" type="button">This Week</button>
        </div>
      </div>

      <div className="d-grid gap-2 mt-4">
        <button className="btn btn-primary fw-semibold">Apply Filters</button>
        <button className="btn btn-outline-secondary">Reset</button>
      </div>
    </div>
  </div>

</section>


</main>



           
            <Footer />
        </>

    );
};

export default TestingDoctorList